export const LOCALE_STORAGE_KEY = 'app_locale';
export const SUPPORTED_LOCALES = ['en', 'it', 'es'];

/** Normalize a language tag (e.g. `es-ES`) to a supported app locale code. */
export function resolveAppLocale(language) {
  const code = String(language || 'en').slice(0, 2).toLowerCase();
  return SUPPORTED_LOCALES.includes(code) ? code : 'en';
}
